import React, { Component } from 'react'
import { ArticleLarge, SpinnerCard } from '../components/common/Layout'
import LoginFormContainer from '../components/login/LoginFormContainer'
import LocationSearchContainer from '../components/location-search/LocationSearchContainer'
import { rootRoute } from '../routes/routes'
import { P } from '@foodsby/nutrient'
import { Redirect, withRouter } from 'react-router-dom'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { currentUserStart } from '../redux/modules/user'
import SlackBotSuccessModal from '../components/slack/SlackBotSuccessModal'

const styles = {
  Header: {
    textTransform: 'Uppercase',
    paddingTop: '60px',
  },
  Login: {
    padding: '32px',
  },
  Search: {
    padding: '32px',
    borderLeft: '1px solid #bfbfbf',
  },
  Title: {
    marginBottom: '16px',
    textAlign: 'center',
  },
}

class PageLogin extends Component {
  componentDidMount() {
    const {
      isCurrentUserLoading,
      isAuthenticated,
      currentUserStart,
    } = this.props
    if (!isCurrentUserLoading && !isAuthenticated) {
      currentUserStart(true, false)
    }
  }

  render() {
    const { isAuthenticated, isCurrentUserLoading, location } = this.props
    const searchParams = queryString.parse(location.search)
    return isAuthenticated && !isCurrentUserLoading ? (
      <Redirect to={rootRoute.path} />
    ) : (
      <ArticleLarge>
        <div>
          <SlackBotSuccessModal />
          <div className="row center-xs">
            <div className="col-xs-12">
              <h1 className="primary" style={styles.Header}>
                Ready to Order?
              </h1>
              <P mb={4}>
                Login to place your next order with Foodsby. Not a member yet?
                Search for your building!
              </P>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-6" style={styles.Login}>
              <h2 className="title" style={styles.Title}>
                Login
              </h2>
              <SpinnerCard spinnerActive={isCurrentUserLoading}>
                <LoginFormContainer path={searchParams.onSuccessPath} />
              </SpinnerCard>
            </div>
            <div className="col-xs-12 col-md-6" style={styles.Search}>
              <h3 className="title" style={styles.Title}>
                Not a member? Find your building
              </h3>
              <SpinnerCard spinnerActive={isCurrentUserLoading}>
                <LocationSearchContainer />
              </SpinnerCard>
            </div>
          </div>
        </div>
      </ArticleLarge>
    )
  }
}
const mapStateToProps = state => {
  const { isAuthenticated, isCurrentUserLoading } = state.user
  return {
    isAuthenticated,
    isCurrentUserLoading,
  }
}
const mapDispatchToProps = {
  currentUserStart,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageLogin),
)
